import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import noop from 'lodash/noop';
import camelCase from 'lodash/camelCase';

import * as actions from './TwitterImports.ducks';

import Button from 'zignal-landscape/lib/Button';
import Add1Icon from 'zignal-landscape/lib/Icon/Add1Icon';
import InformationIcon from 'zignal-landscape/lib/Icon/InformationIcon';
import Heading from 'zignal-landscape/lib/Heading';
import Loading from 'zignal-landscape/lib/Loading';
import themeable from 'zignal-landscape/lib/themeable';
import ThemeProvider from 'zignal-landscape/lib/ThemeProvider';
import Checkbox from 'zignal-landscape/lib/Checkbox';
import Label from 'zignal-landscape/lib/Label';
import Select from 'zignal-landscape/lib/Select';


import { Light } from 'themes';

import TwitterImportsNew from './components/TwitterImportsNew';
import TwitterImportsTable from './components/TwitterImportsTable';
import ImportModal from '../HistoricalImport/components/ImportModal';

const FILTER_LIST = ['Any', 'Queued', 'In Progress', 'Succeeded', 'Failed'];

export const mapStateToProps = (
  (state) => ({
    twitterImports: state.TwitterImports.twitterImports,
    total: state.TwitterImports.total,
    isFetching: state.TwitterImports.isFetching,
    //new import
    profiles: state.TwitterImports.profiles,
    selectedCampaign: state.TwitterImports.selectedCampaign,
    selectedProfiles: state.TwitterImports.selectedProfiles,
    selectedFilters: state.TwitterImports.selectedFilters,
    jobType: state.TwitterImports.jobType,
    startDate: state.TwitterImports.startDate,
    endDate: state.TwitterImports.endDate,
    saving: state.TwitterImports.saving,
    bannerTitle: state.TwitterImports.bannerTitle,
    bannerText: state.TwitterImports.bannerText,
    bannerType: state.TwitterImports.bannerType,
    showBanner: state.TwitterImports.showBanner,
    updateTwitterJobChangeError: state.TwitterImports.updateTwitterJobChangeError,
    timezone: state.AppUser.user.timezone,
    timezone_offset: state.AppUser.user.timezone_offset,
    user: state.AppUser.user,
    estimate: state.TwitterImports.estimate
  })
);

export const mergeProps = (stateProps, dispatchProps, ownProps) => {
  return Object.assign({}, stateProps, dispatchProps, ownProps);
};

class TwitterImports extends Component {
  constructor(props) {
    super(props);
    this.setSelectedFilters = this.setSelectedFilters.bind(this);
    this.state = {
      filterList: FILTER_LIST
        .map((filter) => ({
          id: camelCase(filter),
          name: filter,
          label: filter,
          checked: true,
          value: camelCase(filter)
        })),
      selectedFilters: []
    };
  }

  componentDidMount() {
    const {
      newImport, accountId, campaign, profilesDefault, fetchTwitterImports, newImportInit, onNewElementAdded
    } = this.props;

    actions.newElementAdded(onNewElementAdded);

    if(newImport) {
      return newImportInit(accountId, campaign.id, profilesDefault);
    }

    return fetchTwitterImports(this.state.selectedFilters);
  }

  setSelectedFilters(event) {
    const newSelectedFilters = new Set([event.id]);
    let newFilterList = this.state.filterList;

    newFilterList = newFilterList.map((x) => {
      x.checked = newSelectedFilters.has(x.id);
      return x;
    });

    this.setState({
      filterList: newFilterList,
      selectedFilters: Array.from(newSelectedFilters)
    }, () => {
      this.props.fetchTwitterImports(this.state.selectedFilters);
    });
  }

  render() {
    const {
      newImport,
      campaign,
      campaigns,
      profiles,
      selectedCampaign,
      selectedProfiles,
      jobType,
      startDate,
      endDate,
      handleCampaignChange,
      handleProfilesChange,
      handleDateRangeChange,
      handleSubmit,
      fetchTwitterImports,
      isFetching,
      twitterImports,
      total,
      saving,
      showBanner,
      handleCloseBanner,
      bannerTitle,
      bannerText,
      bannerType,
      styles,
      updateTwitterJobChangeError,
      updateTwitterCleanErrorStatusMessage,
      updateTwitterChangeStatus,
      timezone,
      user,
      estimate,
      handleTwitterModalClosed,
      timezone_offset,
      createTwitterImport
    } = this.props;

    const title = newImport ? 'Create New TWITTER Import' : 'TWITTER Imports';
    const createImportButton = (
      <Button icon={<Add1Icon />} id="create-import">Create New Import</Button>
    );

    const loader = (<div className={styles.loadingSection}><Loading /></div>);

    const emptyTable = (
      <div className={styles.TwitterImportsEmptyTable}>
        <span className={styles.TwitterImportsEmptyTableIcon}><InformationIcon width={45} height={45} /></span>
        <div className={styles.TwitterImportsEmptyTableTitle}>No TWITTER Imports to Display</div>
        <footer>{createImportButton}</footer>
      </div>
    );

    const renderFilters = (filterItem, index) => {
      let value = '';
      if (this.state.selectedFilters && this.state.selectedFilters.length) {
        value = this.state.selectedFilters[0];
        value = filterItem.find(filter => filter.id === value);
      }

      return (
        <div className={styles.TwitterImportFilterSelect}>
          <Select
            id={filterItem.id}
            placeholder={'Filters'}
            onChange={this.setSelectedFilters}
            options={filterItem}
            defaultValue={value}
            value={value}
          />
          <Label htmlFor={filterItem.id} inline>{filterItem.name}</Label>
        </div>
      );
    };

    const renderTable = !isFetching && !twitterImports.length ?
      emptyTable :
      (
        <div>
          <TwitterImportsTable
            twitterImports={twitterImports}
            onLoadMore={/* v8 ignore next */() => fetchTwitterImports(this.state.selectedFilters)}
            hasMore={(total - twitterImports.length) > 0}
            styles={styles}
            errorOnChangeStatus={updateTwitterJobChangeError}
            onCleanError={updateTwitterCleanErrorStatusMessage}
            accept={/* v8 ignore next */(uuid, campaignId, campaignIds, startDate) => {
              updateTwitterChangeStatus({
                'jobType': 'import',
                'status':'accept',
                'jobUuid': uuid,
                campaignId,
                campaignIds,
                startDate
              });
            }}
            timezone={timezone}
          />
          <footer className={styles.TwitterImportsTableFooter} />
        </div>
      );

    // renders global loader if fetching with no records yet
    const content = isFetching && !twitterImports.length ? loader : renderTable;

    const components = newImport ? (
      <TwitterImportsNew
        campaign={campaign}
        campaigns={campaigns}
        profiles={profiles}
        selectedCampaign={selectedCampaign}
        selectedProfiles={selectedProfiles}
        jobType={jobType}
        startDate={startDate}
        endDate={endDate}
        handleCampaignChange={handleCampaignChange}
        handleProfilesChange={handleProfilesChange}
        handleDateRangeChange={handleDateRangeChange}
        handleSubmit={() => {
          handleSubmit();

        }}
        handleCloseBanner={handleCloseBanner}
        saving={saving}
        bannerTitle={bannerTitle}
        bannerText={bannerText}
        bannerType={bannerType}
        showBanner={showBanner}
        timezone={timezone}
        styles={styles}
      /> ) : content;

    const filterComponent = (!isFetching && !newImport) && (
      <div className={styles.TwitterImportHeader}>
        <div id="import-filter" className={styles.TwitterImportFilter}>
          {  renderFilters(this.state.filterList) }
        </div>
        {
          twitterImports.length !== 0 && (
            <div className={styles.createImportButtonWrapper}>
              {createImportButton}
            </div>
          )
        }
      </div>
    );

    return (
      <ThemeProvider theme={Light}>
        <div>
          <Heading>{title}</Heading>
          {filterComponent}
          {components}
        </div>
        <ImportModal
          user={user}
          timezoneOffset={timezone_offset}
          campaignId={campaign?.id || ''}
          estimate={estimate || null}
          disableImportButton={!estimate}
          cancelImport={handleTwitterModalClosed}
          importStories={() => {
            createTwitterImport();
            fetchTwitterImports(this.state.selectedFilters);
          }}
          trackBaselineHistoric={{}}
        />
      </ThemeProvider>
    );
  }
}

TwitterImports.propTypes = {
  accountId: PropTypes.string,
  styles: PropTypes.object,
  twitterImports: PropTypes.array,
  fetchTwitterImports: PropTypes.func,
  total: PropTypes.number,
  isFetching: PropTypes.bool,
  // new twitter import
  newImport: PropTypes.bool.isRequired,
  onNewElementAdded: PropTypes.func,
  campaign: PropTypes.object,
  campaigns: PropTypes.array,
  profiles: PropTypes.array,
  profilesDefault: PropTypes.array,
  selectedCampaign: PropTypes.array,
  selectedProfiles: PropTypes.object,
  jobType: PropTypes.string,
  startDate: PropTypes.string,
  endDate: PropTypes.string,
  handleCampaignChange: PropTypes.func,
  handleDateRangeChange: PropTypes.func,
  handleProfilesChange: PropTypes.func,
  handleSubmit: PropTypes.func,
  saving: PropTypes.bool,
  newImportInit: PropTypes.func,
  showBanner: PropTypes.bool,
  handleCloseBanner: PropTypes.func,
  bannerTitle: PropTypes.string,
  bannerText: PropTypes.string,
  bannerType: PropTypes.string,
  updateTwitterChangeStatus: PropTypes.func,
  updateTwitterJobChangeError : PropTypes.object,
  updateTwitterCleanErrorStatusMessage: PropTypes.func,
  timezone: PropTypes.string
};

TwitterImports.defaultProps = {
  onNewElementAdded: noop,
};

export default connect(mapStateToProps, actions, mergeProps)(themeable(TwitterImports));
